const g:any = window[ENV.projectName] = window[ENV.projectName] || {};

import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator';
import { mainStore } from '../_store/main';
import OnScreenImg from './OnScreenImg';

import gsap, { Expo } from 'gsap/gsap-core';
import { SimpleLayoutMode } from '../_types/common';

@Component
export class TechnologySection extends OnScreenImg {
  public isCurrent: boolean = false;

  get isVisible() {
    if(mainStore.simpleLayoutMode === SimpleLayoutMode.L) {
      return this.isCurrent;
    } else {
      return true;
    }
  }

  get classObj() {
    return {
      'is-current': this.isCurrent && mainStore.simpleLayoutMode === SimpleLayoutMode.L,
      'is-onScreenImgLoaded': this.isLoaded,
      'is-onScreen': this.isOnScreen && this.isVisible,
      'is-onScreenImg': this.isAvailable,
      'is-onScreenItem': this.isAvailable,
      'is-video': this.type === 'video'
    }
  }

  public getOffsetTop() {
    return (this.$el as HTMLDivElement)?.offsetHeight || 0;
  }

  @Ref('visual')
  public visual!: HTMLDivElement;
}

@Component
export default class TechnologySections extends Vue {
  protected isActive: boolean = false;
  protected numSections: number = 0;
  protected height: number = 0;
  protected sections: TechnologySection[] = [];

  public currentIndex: number = -1;
  public isAnimating: boolean = false;

  @Ref('anchor')
  protected anchor!: HTMLDivElement;

  get isFirst() {
    return this.currentIndex <= 0;
  }
  get isLast() {
    return this.currentIndex === this.numSections - 1;
  }

  public onResize() {
    this.height = 0;

    for (let i = 0; i < this.numSections; i++) {
      this.height = Math.max(this.height, this.sections[i].getOffsetTop());
    }
  }

  public setActive(isActive: boolean) { this.isActive = isActive; }
  public getActive() { return this.isActive; }

  get styleObj() {
    if(mainStore.simpleLayoutMode === SimpleLayoutMode.L) {
      return {
        height: `${this.height}px`
      }
    } else {
      return null;
    }
  }

  public async init(sections: TechnologySection[]) {
    this.sections = sections;
    this.numSections = this.sections.length;
    this.onResize();
    return this.$nextTick();
  }

  public prev() {
    if(this.isFirst) return;
    this.setIndex(--this.currentIndex);
  }

  public next() {
    if(this.isLast) return;
    this.setIndex(++this.currentIndex);
  }

  public setIndex(index: number) {
    if(this.isAnimating) return;

    this.isAnimating = true;
    window.setTimeout(()=> {
      this.isAnimating = false;
    }, 1600);

    this.currentIndex = index;
    console.log(this.currentIndex);
    for (let i = 0; i < this.numSections; i++) {
      this.sections[i].isCurrent = index === i;
    }
  }

  public getAnchorOffsetTop() {
    return this.anchor? g.getOffsetTop(this.anchor): 0;
  }
}